Instructions on how this candidate should be distributed.
